<template>
  <div class="container">
    <div class="filter">
      <div class="tabs">
        <span
          class="tabbar-item"
          @click="queryAdmasterCat('游戏', 0)"
          :class="activeIndex == 0 ? 'active' : ''"
          >游戏排行榜</span
        >
        <span
          class="tabbar-item"
          @click="queryAdmasterCat('应用', 1)"
          :class="activeIndex == 1 ? 'active' : ''"
          >应用排行榜</span
        >
        <span
          class="tabbar-item"
          @click="queryAdmasterCat('品牌', 2)"
          :class="activeIndex == 2 ? 'active' : ''"
          >品牌排行榜</span
        >
      </div>
      <div class="tabs-content">
        <div class="inner">
          <div><span>分类</span></div>
          <ul>
            <li
              class="tag"
              :class="tagActiveIndex == 0 ? 'active' : ''"
              @click="queryAdmasterSubCat('', 0)"
            >
              全部
            </li>
            <li
              class="tag"
              v-for="(tag, index) in tags"
              :key="tag"
              :class="tagActiveIndex == index + 1 ? 'active' : ''"
              @click="queryAdmasterSubCat(tag, index + 1)"
            >
              {{ tag }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main">
      <div>
        <el-table
          class="table"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column
            label="排名"
            type="index"
            :index="indexMethod"
            width="80"
          >
          </el-table-column>
          <el-table-column prop="advertiser" label="广告主" width="180">
            <template slot-scope="scope">
              <router-link
                class="name text-align-left"
                :to="{
                  path:
                    '/admaster-detail?name=' +
                    scope.row.advertiser +
                    '&start=' +
                    scope.row.stTimestampSec +
                    '&end=' +
                    scope.row.edTimestampSec,
                }"
              >
                {{ scope.row.advertiser }}
              </router-link></template
            >
          </el-table-column>
          <el-table-column prop="imageNum" label="素材数" width="80">
          </el-table-column>
          <el-table-column label="投放渠道" width="120">
            <template slot-scope="scope">
              <div
                class="platform-item"
                v-for="item in scope.row.plaforms"
                :key="item"
              >
                <img
                  class="icon"
                  v-if="item == 'gdt'"
                  src="../assets/img/优量汇.png"
                  alt="优量汇"
                /><img
                  class="icon"
                  v-else-if="item == 'toutiao'"
                  src="../assets/img/头条.png"
                  alt="头条"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="投放系统" width="160">
            <template slot-scope="scope">
              <div
                class="system-item"
                v-for="item in scope.row.deviceTypes"
                :key="item"
              >
                <img
                  class="icon"
                  v-if="item == 'Android'"
                  src="../assets/img/安卓.png"
                  alt="安卓"
                /><img
                  class="icon"
                  v-else
                  src="../assets/img/苹果.png"
                  alt="iOS"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="showDayNumOneYear"
            label="近一年投放天数"
            width="120"
          >
            <template slot-scope="scope">
              <div class="text-align-center">
                {{ scope.row.showDayNumOneYear }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="最近投放周期">
            <template slot-scope="scope">
              {{ scope.row.stTimestampSec | dateFormat }} ~
              {{ scope.row.edTimestampSec | dateFormat }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pager">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="curPage"
        :page-size="10"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "Admaster",
  mounted() {
    let session = this.$route.query["session"];
    if (!!session) {
      sessionStorage.setItem("session", session);
      sessionStorage.setItem("isLogin", "1");
    }
    this.queryAdmasterCat("游戏");
    this.queryAdmasterMeterial();
    this.$root.Search = this.queryAdmasterMeterial();
  },
  created() {
    this.$eventBus.$on("search", (arg) => {
      console.log("on监听参数====", arg);
    });
  },
  destoryed() {
    this.$EventBus.$off("search");
  },
  data() {
    return {
      activeIndex: 0,
      catArr: ["游戏", "应用", "品牌"],
      tagActiveIndex: 0,
      cat: "游戏",
      subCat: "休闲益智",
      tags: [],
      value: "",
      tableData: [],
      curPage: 1,
      total: 0,
    };
  },
  methods: {
    indexMethod(index) {
      return "TOP " + (index + 1 + 10 * (this.curPage - 1));
    },
    handleSizeChange() {},
    handleCurrentChange(page) {
      this.curPage = page;
      this.queryAdmasterMeterial();
    },
    queryAdmasterMeterial() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
      });
      let option = {
        options: {
          l1Classification: this.cat,
          l2Classification: this.subCat,
        },
        page: this.curPage - 1,
        cnt: 10,
      };
      console.log(option);
      this.$http
        .post("/fireeye/advertiser/search", option)
        .then((res) => {
          console.log(res);
          let data = res.data;
          if (data.code == 1) {
            this.total = data.all;
            this.tableData = data.data;
          } else {
            console.log("获取数据失败");
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    queryAdmasterCat(cat, index) {
      this.curPage = 1;
      this.activeIndex = parseInt(index);
      this.tagActiveIndex = 0;
      this.subCat = "";
      this.$http
        .get("/fireeye/advertiser/type/list?industry=" + cat)
        .then((res) => {
          console.log(res);
          let data = res.data;
          if (data.code === 1) {
            this.tags = data.data;
            this.cat = cat;
            this.queryAdmasterMeterial();
          } else {
            console.log(data.msg);
          }
        });
    },
    queryAdmasterSubCat(cat, index) {
      this.curPage = 1;
      this.tagActiveIndex = parseInt(index);
      this.subCat = cat;
      this.queryAdmasterMeterial();
    },
  },
};
</script>
<style lang="less" scoped>
.filter {
  font-size: 12px;
  background-color: #fff;
  box-shadow: 0 0 5px #ddd;
  border-radius: 4px;
  padding: 25px 15px;

  .tabs {
    justify-content: space-around;
    margin-bottom: 20px;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 25px;
  }
  .tabbar-item {
    display: inline-block;
    padding: 8px 0;
    font-weight: 600;
    font-size: 14px;
    margin-right: 40px;
  }
  .tabbar-item:hover {
    cursor: pointer;
  }
  .tabbar-item.active {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2196f3;
    line-height: 25px;
  }
  .tabs-content {
    .inner {
      background-color: #f2f2f2;
      display: flex;
      border-radius: 4px;
      div {
        margin: 1em;
        padding: 10px;
        font-weight: 600;
      }
      ul {
        flex: 1;
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        padding-left: 0;

        .tag {
          padding: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #212121;
          line-height: 20px;
        }
        .tag:hover {
          cursor: pointer;
        }
        .tag.active {
          font-family: PingFangSC-Regular, PingFang SC;
          color: #2196f3;
        }
      }
    }
  }
}
.main {
  margin-top: 36px;
  .text-align-left {
    text-align: left;
  }

  .name {
    text-decoration: none;
    color: #666;
    display: block;
  }
  .platform-item,
  .system-item {
    margin-right: 10px;
    display: inline-block;

    .icon {
      width: 20px;
      height: 20px;
    }
  }
}
.pager {
  margin: 30px 0 60px;
}
</style>